// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"aa6fbf25e83571f9406a","678":"14aa82b4c9f2ffcec067","883":"928141ead4a7ce1f4865"}[chunkId] + ".js";
};